import {
    issueList
} from './data'
// 生成随机的中文名字
function generateRandomChineseName() {
    var firstNames = ["张", "王", "李", "赵", "刘", "陈", "杨", "黄", "周", "吴", "徐", "孙", "胡", "朱", "高", "林", "何", "郭", "马", "罗", "梁", "宋", "郑", "谢", "韩", "唐", "冯", "于", "董", "萧", "程", "曹", "袁", "邓", "许", "傅", "沈", "曾", "彭", "吕", "苏", "卢", "蒋", "蔡", "贾", "丁", "魏", "薛", "叶", "阎", "余", "潘", "杜", "戴", "夏", "锺", "汪", "田", "任", "姜", "范", "方", "石", "姚", "谭", "廖", "邹", "熊", "金", "陆", "郝", "孔", "白", "崔", "康", "毛", "邱", "秦", "江", "史", "顾", "侯", "邵", "孟", "龙", "万", "段", "雷", "钱", "汤", "尹", "黎", "易", "常", "武", "乔", "贺", "赖", "龚", "文"];
    var lastNames = ["伟", "芳", "娜", "秀英", "静", "敏", "磊", "洋", "艳", "勇", "强", "军", "杰", "娟", "涛", "明", "超", "秀兰", "霞", "平", "刚", "桂英"];

    var firstNameIndex = Math.floor(Math.random() * firstNames.length);
    var lastNameIndex = Math.floor(Math.random() * lastNames.length);

    return firstNames[firstNameIndex] + lastNames[lastNameIndex];
}

export const getRandomMessages = () => {
    // 假设这是您提供的包含问题和消息的 JSON 数据
    var jsonData = issueList;

    // 创建一个数组来存储每个问题对应的随机消息
    var randomMessages = [];

    // 遍历所有问题
    jsonData.forEach(function (data) {
        // 获取当前问题的消息数组
        var messages = data.messages;

        // 随机选择一个消息
        var randomIndex = Math.floor(Math.random() * messages.length);
        var randomMessage = messages[randomIndex];

        // 生成随机中文名
        var randomName = generateRandomChineseName();

        // 将随机消息存储到数组中
        var obj = {
            name: randomName,
            question: {
                issue: data.issue,
                messages: randomMessage
            }
        };
        randomMessages.push(obj);
    });

    // 返回包含随机消息的数组
    return randomMessages;
}

// 调用方法获取随机消息数组